import { useState, useRef } from "react";
import { API_URL, isFieldError } from "../helpers";
import Input from "../components/Input";
import Select from "../components/Select";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Form = ({ details }) => {
	const [names, setNames] = useState({});
	const [errors, setErrors] = useState([]);
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/volunteering`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				//submitted(json.text);
				formElement.current.fname.value = "";
				formElement.current.lname.value = "";
				formElement.current.email.value = "";
				formElement.current.phone.value = "";
				formElement.current.committee.selectedIndex = 0;
				setNames({});

				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
			style={{ marginBottom: "30px" }}
		>
			<p style={{ marginTop: "0" }}>
				Sign up to be notified when registration is open for your desired
				committee(s).
			</p>

			<p>Please complete the process for each desired committee separately.</p>

			<div className="form-group">
				<Input
					name="fname"
					label="First Name"
					reqd={true}
					value={names.fname || ""}
					autocomplete="given-name"
					update={handleUpdate}
					errors={errors}
				/>
				<Input
					name="lname"
					label="Last Name"
					reqd={true}
					value={names.lname || ""}
					autocomplete="family-name"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group">
				<Input
					name="email"
					label="Email"
					reqd={true}
					value={names.email || ""}
					update={handleUpdate}
					errors={errors}
				/>
				<Input
					name="phone"
					label="Mobile / Cell Number"
					reqd={true}
					value={names.phone || ""}
					autocomplete="tel"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group">
				<Select
					name="committee"
					label="Select Committee"
					reqd={true}
					value={""}
					options={details.committees}
					autocomplete="off"
					update={handleUpdate}
					error={isFieldError(errors, "committee")}
				/>

				<div className="empty" />
			</div>

			<div className="msg-submit">
				{msg.type && <Msg data={msg} />}

				<div className={msg.type === "working" ? "hidden" : "submit-container"}>
					<Submit submit="Register Notification" />
				</div>
			</div>
		</form>
	);
};

export default Form;
